import React               from 'react';
import classnames          from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default (props) => {
  return (
    <div className="info">
      <div className="fw-bold">
        Don't have a BOM file ready?
      </div>
      <div>
        <a className="skip-online-part" href="#">Skip</a> online parts 
        quoting and we'll get you parts quote after your order is placed, 
        or you may remove parts sourcing for this order.
      </div>
    </div>
  );
};
